import { ResourceNotFoundException } from '@amzn/helianthus-arbiter-client';
import { ErrorState } from '../../components/ErrorState';

/** Not-found or API-error state for a rule that failed to load; shared by the detail and edit pages. */
export function RuleLoadError({ ruleName, error }: { ruleName: string | undefined; error: Error | null }) {
  const is404 = error instanceof ResourceNotFoundException;
  return (
    <ErrorState
      variant={is404 ? 'not-found' : 'api-error'}
      title={is404 ? 'Rule not found' : 'Error loading rule'}
      message={is404
        ? `The rule "${ruleName}" could not be found. It may have been deleted.`
        : (error?.message || 'Rule not found')}
      onRetry={!is404 ? () => window.location.reload() : undefined}
      backLabel="Back to Rules"
      backHref="/rules"
    />
  );
}
